var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcObjectDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20093 2.69922H3.10093C2.88001 2.69922 2.70093 2.87831 2.70093 3.09922V7.19922C2.70093 7.42013 2.88001 7.59922 3.10093 7.59922H7.20093C7.42184 7.59922 7.60093 7.42013 7.60093 7.19922V3.09922C7.60093 2.8783 7.42184 2.69922 7.20093 2.69922Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9009 2.69922H10.8009C10.58 2.69922 10.4009 2.87831 10.4009 3.09922V7.19922C10.4009 7.42013 10.58 7.59922 10.8009 7.59922H14.9009C15.1218 7.59922 15.3009 7.42013 15.3009 7.19922V3.09922C15.3009 2.8783 15.1218 2.69922 14.9009 2.69922Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9009 10.3984H10.8009C10.58 10.3984 10.4009 10.5775 10.4009 10.7984V14.8984C10.4009 15.1194 10.58 15.2984 10.8009 15.2984H14.9009C15.1218 15.2984 15.3009 15.1194 15.3009 14.8984V10.7984C15.3009 10.5775 15.1218 10.3984 14.9009 10.3984Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20093 10.3984H3.10093C2.88001 10.3984 2.70093 10.5775 2.70093 10.7984V14.8984C2.70093 15.1194 2.88001 15.2984 3.10093 15.2984H7.20093C7.42184 15.2984 7.60093 15.1194 7.60093 14.8984V10.7984C7.60093 10.5775 7.42184 10.3984 7.20093 10.3984Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcObjectDefault);
export default __webpack_public_path__ + "static/media/ic_object_default.cb2f1be2a1e65c51dee447e7addaa733.svg";
export { ForwardRef as ReactComponent };